import gql from 'graphql-tag'

export default gql`
query listLoyaltyCardGroups {
	cashAssist {
		listLoyaltyCardGroups {
			hasNextPage
			items {
				id
				name
			}
			cursors {
				hasNext
				hasPrevious
			}
		}
	}
}
`
